import { jsx as r } from "react/jsx-runtime";
import { w as i } from "../../../vendor-CPVnY93G.js";
import { forwardRef as a, useContext as s } from "react";
import { MultiSelectValue as c } from "./MultiValue.js";
import { SingleSelectValue as m } from "./SingleValue.js";
const V = a(
  ({ placeholder: e, startIcon: t }, o) => {
    const l = s(i)?.selectionManager.selectionMode === "multiple" ? c : m;
    return /* @__PURE__ */ r(
      l,
      {
        "data-component": "SelectValue",
        ref: o,
        placeholder: e,
        startIcon: t
      }
    );
  }
);
export {
  V as SelectValue
};
